// extracted by mini-css-extract-plugin
export default {"modalVideo":"video-modal_modalVideo__rbccX","videoModal":"video-modal_videoModal__uVil8"};